module.exports = __webpack_public_path__ + "img/carousel_four_icon.0.1.0_202503250930.png";